import React, { FC } from "react";
import { Id, Role } from "../../../types";
import { useMachine } from "@xstate/react";
import { fetchMachine } from "../../../machines/fetch";
import { addRole } from "../../../api/add-role";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { activeSubscriptionIdState, rolesState } from "../../../atoms";
import { useForm } from "react-hook-form";
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Stack,
  useToast,
} from "@chakra-ui/react";

type FormData = Pick<Role, "name">;

type Props = {
  onSuccess: (newRoleId: Id) => void;
};

export const AddRole: FC<Props> = (props) => {
  const { onSuccess } = props;

  const toast = useToast();

  const activeSubscriptionId = useRecoilValue(activeSubscriptionIdState);
  const setRoles = useSetRecoilState(rolesState);

  const { register, handleSubmit, errors, watch } = useForm<FormData>();
  const watchName = watch("name");

  const onSubmit = () => {
    send(state.matches("failure") ? "RETRY" : "FETCH");
  };

  const [state, send] = useMachine(fetchMachine, {
    services: {
      fetch: () =>
        addRole({
          name: watchName,
          subscriptionId: activeSubscriptionId as Id,
        }),
    },

    actions: {
      success: (_, event: any) => {
        setRoles(event.data.roles);
        onSuccess(event.data.newRoleId);
        toast({
          title: "rol toegevoegd",
          status: "success",
          isClosable: true,
        });
      },

      failure: (_, event: any) => {
        toast({
          title: "toevoegen van rol niet gelukt",
          description: JSON.stringify(event.data, null, 2),
          status: "error",
          isClosable: true,
        });
      },
    },
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={8} align="start">
        <FormControl isRequired isInvalid={errors.name !== undefined}>
          <FormLabel>naam</FormLabel>
          <Input
            name="name"
            ref={register({
              required: "je hebt geen naam ingevuld",
            })}
          />
          <FormErrorMessage>{errors.name?.message}</FormErrorMessage>
        </FormControl>

        <Button type="submit" size="sm" isLoading={state.matches("loading")}>
          voeg toe
        </Button>
      </Stack>
    </form>
  );
};
